import { render, staticRenderFns } from "./indx.vue?vue&type=template&id=174d28fb&scoped=true&"
import script from "./indx.vue?vue&type=script&lang=js&"
export * from "./indx.vue?vue&type=script&lang=js&"
import style0 from "./indx.vue?vue&type=style&index=0&id=174d28fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174d28fb",
  null
  
)

export default component.exports